import type { Core } from 'chessboard/core/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Run a plugin.
 */
export function runPlugin(plugin: Plugins.Model, params: [Core.Event, Core.Context]): void {
  if (!plugin.match) {
    return;
  }

  plugin.match.forEach((match: Plugins.Match) => run(match, params));

  /**
   * Attempt to handle the event.
   */
  function run(match: Plugins.Match, matchParams: [Core.Event, Core.Context]): void {
    if (!match.condition(...matchParams)) {
      return;
    }

    match.handler(...matchParams);
  }
}
